import Vue from 'vue';
import App from './App';
import router from './router';
import { store } from './resources';

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#navigabilis',
  router,
  store: store,
  template: '<App />',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js